module.exports = __webpack_public_path__ + "img/ID_Tagline_white.16db69c2.png";